import _createClass from "@babel/runtime/helpers/esm/createClass";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _dec, _class, _NumericType;
function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}
/** @jsx jsx */
import { Component } from 'react';
import PropTypes from 'prop-types';
import AfsTableWrapper from '../shared/AfsTableWrapper';
import { AfsPartsContainer } from '../shared/AfsPartsContainer/presenter';
import AggregationTable from '../shared/AggregationTable';
import ExpandableCard from '../shared/ExpandableCard';
import { Text } from '@instructure/ui-text';
import t from '@instructure/quiz-i18n/format-message';
import ChoiceTypeTable from '../shared/ChoiceTypeTable';
import { jsx } from '@instructure/emotion';
import ChoiceTypeWithInfo from './ChoiceTypeWithInfo';
import generateStyle from './styles';
import generateComponentTheme from './theme';
import { numericTypeAnswerSummaryPropType } from '../../../common/propTypes';
import { Flex, withStyleOverrides } from '@instructure/quiz-common';
export var NumericType = (_dec = withStyleOverrides(generateStyle, generateComponentTheme), _dec(_class = (_NumericType = /*#__PURE__*/function (_Component) {
  function NumericType() {
    var _this2;
    _classCallCheck(this, NumericType);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this2 = _callSuper(this, NumericType, [].concat(args));
    _defineProperty(_this2, "renderIncorrectTable", function () {
      var _this2$props = _this2.props,
        itemId = _this2$props.itemId,
        answerSummary = _this2$props.answerSummary;
      var incorrect_answer_choices = answerSummary.requirements.incorrect_answer_choices;
      var tableId = "".concat(itemId, "_incorrect_choices");
      var tableContainerStyles = {};
      return jsx(ChoiceTypeTable, {
        itemId: tableId,
        choices: incorrect_answer_choices,
        tableContainerStyles: tableContainerStyles
      });
    });
    _defineProperty(_this2, "getPreciseTypeTranslatable", function (precisionType) {
      switch (precisionType) {
        case 'significantDigits':
          return t('Significant Digits');
        case 'decimals':
          return t('Decimal Places');
        default:
          return precisionType;
      }
    });
    _defineProperty(_this2, "renderPreciseResponse", function (correct_answers) {
      var typeString = "".concat(t('Correct answer'), " - ").concat(t('Precise Response'), " ");
      var answerString = "".concat(t('Answer'), ": ").concat(correct_answers.value, " ");
      var precisionString = "".concat(t('Precision'), ": ").concat(correct_answers.precision, " ");
      var translatablePrecisionType = _this2.getPreciseTypeTranslatable(correct_answers.precision_type);
      var precisionTypeString = "".concat(t('Type'), ": ").concat(translatablePrecisionType, " ");
      return jsx("div", {
        css: _this2.props.styles.groupAggregationContainer
      }, jsx(Text, {
        transform: "capitalize",
        weight: "bold"
      }, typeString), jsx(Text, {
        transform: "capitalize"
      }, answerString), jsx(Text, {
        transform: "capitalize"
      }, precisionString), jsx(Text, {
        transform: "capitalize"
      }, precisionTypeString));
    });
    _defineProperty(_this2, "getMarginTypeTranslatable", function (marginType) {
      switch (marginType) {
        case 'absolute':
          return t('Absolute');
        case 'percent':
          return t('Percent');
        default:
          return marginType;
      }
    });
    _defineProperty(_this2, "renderMarginOfError", function (correct_answers) {
      var typeString = "".concat(t('Correct answer'), " - ").concat(t('Margin Of Error'), " ");
      var answerString = "".concat(t('Answer'), ": ").concat(correct_answers.value, " ");
      var marginString = "".concat(t('+/- margin'), ": ").concat(correct_answers.margin, " ");
      var translatableMarginType = _this2.getMarginTypeTranslatable(correct_answers.margin_type);
      var marginTypeString = "".concat(t('Type'), ": ").concat(translatableMarginType, " ");
      return jsx("div", {
        css: _this2.props.styles.groupAggregationContainer
      }, jsx(Text, {
        transform: "capitalize",
        weight: "bold"
      }, typeString), jsx(Text, {
        transform: "capitalize"
      }, answerString), jsx(Text, {
        transform: "capitalize"
      }, marginString), jsx(Text, {
        transform: "capitalize"
      }, marginTypeString));
    });
    _defineProperty(_this2, "renderExactResponse", function (correct_answers) {
      var typeString = "".concat(t('Correct answer'), " - ").concat(t('Exact Response'), " ");
      var answerString = "".concat(t('Answer'), ": ").concat(correct_answers.value, " ");
      return jsx("div", {
        css: _this2.props.styles.groupAggregationContainer
      }, jsx(Text, {
        transform: "capitalize",
        weight: "bold"
      }, typeString), jsx(Text, {
        transform: "capitalize"
      }, answerString));
    });
    _defineProperty(_this2, "renderWithinRange", function (correct_answers) {
      var typeString = "".concat(t('Correct answer'), " - ").concat(t('Within A Range'), " ");
      var startString = "".concat(t('Range Starts'), ": ").concat(correct_answers.start, " ");
      var endString = "".concat(t('Range Ends'), ": ").concat(correct_answers.end, " ");
      return jsx("div", {
        css: _this2.props.styles.groupAggregationContainer
      }, jsx(Text, {
        transform: "capitalize",
        weight: "bold"
      }, typeString), jsx(Text, {
        transform: "capitalize"
      }, startString), jsx(Text, {
        transform: "capitalize"
      }, endString));
    });
    _defineProperty(_this2, "renderUncategorized", function () {
      var typeString = "".concat(t('Correct answer'), " - ").concat(t('Uncategorized'), " ");
      return jsx("div", {
        css: _this2.props.styles.groupAggregationContainer
      }, jsx(Text, {
        transform: "capitalize",
        weight: "bold"
      }, typeString));
    });
    _defineProperty(_this2, "getHeadLineByType", function (correct_answer) {
      switch (correct_answer.type) {
        case 'withinARange':
          return _this2.renderWithinRange(correct_answer);
        case 'exactResponse':
          return _this2.renderExactResponse(correct_answer);
        case 'preciseResponse':
          return _this2.renderPreciseResponse(correct_answer);
        case 'marginOfError':
          return _this2.renderMarginOfError(correct_answer);
        default:
          return _this2.renderUncategorized();
      }
    });
    _defineProperty(_this2, "renderChoiceTypeWithInfo", function (correct_answer, index, itemId) {
      var key = "ChoiceTypeWithInfo_".concat(itemId, "_").concat(index);
      return jsx(ChoiceTypeWithInfo, {
        key: key,
        itemId: itemId,
        choices: correct_answer.choices,
        headLine: _this2.getHeadLineByType(correct_answer),
        index: index
      });
    });
    _defineProperty(_this2, "renderCorrectChoiceTypes", function () {
      var _this2$props2 = _this2.props,
        itemId = _this2$props2.itemId,
        answerSummary = _this2$props2.answerSummary;
      var correct_answers = answerSummary.requirements.correct_answers;
      return correct_answers.map(function (correct_answer, index) {
        return _this2.renderChoiceTypeWithInfo(correct_answer, index, itemId);
      });
    });
    _defineProperty(_this2, "renderEmptyIncorrect", function () {
      return jsx(Flex, null, jsx(Flex.Item, {
        padding: "small none small none"
      }, jsx(Text, null, t('There are no incorrect answers.'))));
    });
    _defineProperty(_this2, "renderEmptyCorrect", function () {
      return jsx(Flex, null, jsx(Flex.Item, {
        padding: "small none small none"
      }, jsx(Text, null, t('There are no correct answers.'))));
    });
    _defineProperty(_this2, "renderAfsTable", function () {
      var answerSummary = _this2.props.answerSummary;
      var _answerSummary$requir = answerSummary.requirements,
        correct_answers = _answerSummary$requir.correct_answers,
        incorrect_answer_choices = _answerSummary$requir.incorrect_answer_choices;
      var areThereIncorrectChoices = Array.isArray(incorrect_answer_choices) && incorrect_answer_choices.length > 0;
      var areThereCorrectAnswers = Array.isArray(correct_answers) && correct_answers.length > 0;
      return jsx("div", null, jsx(ExpandableCard, {
        content: areThereCorrectAnswers ? _this2.renderCorrectChoiceTypes() : _this2.renderEmptyCorrect(),
        headLine: jsx(Text, {
          weight: "bold"
        }, t('Correct Answers'))
      }), jsx(ExpandableCard, {
        content: areThereIncorrectChoices ? _this2.renderIncorrectTable() : _this2.renderEmptyIncorrect(),
        headLine: jsx(Text, {
          weight: "bold"
        }, t('Incorrect Answers'))
      }));
    });
    _defineProperty(_this2, "render", function () {
      var _this2$props3 = _this2.props,
        answerSummary = _this2$props3.answerSummary,
        itemId = _this2$props3.itemId;
      return jsx(AfsTableWrapper, null, jsx(AfsPartsContainer, {
        afsTable: _this2.renderAfsTable(),
        aggregationTable: jsx(AggregationTable, {
          itemId: itemId,
          answerSummary: answerSummary
        })
      }));
    });
    return _this2;
  }
  _inherits(NumericType, _Component);
  return _createClass(NumericType);
}(Component), _defineProperty(_NumericType, "displayName", 'NumericType'), _defineProperty(_NumericType, "componentId", "Quizzes".concat(_NumericType.displayName)), _defineProperty(_NumericType, "propTypes", {
  itemId: PropTypes.number.isRequired,
  answerSummary: numericTypeAnswerSummaryPropType.isRequired,
  styles: PropTypes.object
}.isRequired), _NumericType)) || _class);